module.exports = __webpack_public_path__ + "img/bowl-1.ab80377.svg";